var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"b360-btn--primary",class:{ 'b360-btn--disabled': _vm.disabled },attrs:{"disabled":_vm.disabled,"type":"button","id":`upload_widget-${_vm.id}`},on:{"click":_vm.handleUpload}},[_vm._v("\n\tUpload\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }